import { render, staticRenderFns } from "./StaffFormulas.vue?vue&type=template&id=4bbd5ba0"
import script from "./StaffFormulas.vue?vue&type=script&lang=js"
export * from "./StaffFormulas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports